export default __webpack_public_path__ + "static/log-axis-7feb3ad68684d4e86c91dbe6d729b08a.png";